import { getDefaultTextSimple } from '../../helpers';

export default {
    name: "Bandeau d'information",
    blocks: {
        title: getDefaultTextSimple("Titre gras", "Ajouter votre texte", 20, "#666"),
        titlelight: getDefaultTextSimple("Titre", "Ajouter votre texte", 20, "#666"),
    } 
};